import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { DesignStudio } from 'landings/design-studio';
import { RemoteProps } from './widgets-types';

export const DesignStudioRemote: React.FC<RemoteProps> = ({ router, store }) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <DesignStudio />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
